module.exports = __webpack_public_path__ + "static/media/take_the_quiz.cb2bee49.png";